const NAME_VALIDATOR =
  /^([A-zÀ-ÿ$&+,:;=?@#|/\\'ˆ˜<>.*()%!-"'0-9-])+( [A-zÀ-ÿ$&+,:;=?@#|/\\'ˆ˜<>.*()%!-"'0-9-][A-zÀ-ÿ$&+,:;=?@#|/\\ˆ˜'<>.*()%!-"'0-9-]*)+$/
const USERNAME_VALIDATOR = /^[a-zA-Z0-9_.-]+$/
const EMAIL_VALIDATOR = '^([a-zA-Z0-9_\\-\\.+]+)@([a-zA-Z0-9_\\-\\.+]+)\\.([a-zA-Z]{2,20})$'
const MOBILE_PHONE_VALIDATOR = /\([1-9][1-9]\)\s\d{5}-\d{4}/g
const SPECIAL_CHARACTERES_VALIDATOR = /^[-A-ZÀ-Ÿa-zà-ÿ']+( [-A-ZÀ-Ÿa-zà-ÿ']+)+$/
const HIDE_EMAIL = /^(.)(.*)(@.*)$/
const CPF_VALIDATOR = /^[0-9]{11}$/

const PASSWORD_MIN_LENGTH_VALIDATOR = /^.{8,}$/

const PASSWORD_MAX_LENGTH_VALIDATOR = /^.{30,}$/

const PASSWORD_UPPERCASE_ONLY_VALIDATOR = /^[A-Z]*$/

const PASSWORD_LOWERCASE_ONLY_VALIDATOR = /^[a-z]*$/

const PASSWORD_NUMBER_ONLY_VALIDATOR = /^[0-9]*$/

const PASSWORD_SAME_LETTER_VALIDATOR = /([a-zA-Z])\1{2,}/

const PASSWORD_SEQUENCE_LETTER_VALIDATOR =
  /abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz/

const PASSWORD_SEQUENCE_NUMBER_VALIDATOR = /123|234|345|456|567|678|789/

const PASSWORD_UPPERCASE_VALIDATOR = /[A-Z]/

const PASSWORD_LOWECASE_VALIDATOR = /[a-z]/

const PASSWORD_NUMBER_VALIDATOR = /[0-9]/

const PASSWORD_SPECIAL_CHARACTER_VALIDATOR = /[\W_]/

export {
  NAME_VALIDATOR,
  USERNAME_VALIDATOR,
  CPF_VALIDATOR,
  EMAIL_VALIDATOR,
  HIDE_EMAIL,
  MOBILE_PHONE_VALIDATOR,
  SPECIAL_CHARACTERES_VALIDATOR,
  PASSWORD_LOWECASE_VALIDATOR,
  PASSWORD_MAX_LENGTH_VALIDATOR,
  PASSWORD_MIN_LENGTH_VALIDATOR,
  PASSWORD_NUMBER_ONLY_VALIDATOR,
  PASSWORD_NUMBER_VALIDATOR,
  PASSWORD_SAME_LETTER_VALIDATOR,
  PASSWORD_SEQUENCE_LETTER_VALIDATOR,
  PASSWORD_SEQUENCE_NUMBER_VALIDATOR,
  PASSWORD_SPECIAL_CHARACTER_VALIDATOR,
  PASSWORD_UPPERCASE_VALIDATOR,
  PASSWORD_UPPERCASE_ONLY_VALIDATOR,
  PASSWORD_LOWERCASE_ONLY_VALIDATOR,
}
